module.exports = __webpack_public_path__ + "static/media/firebase.49bb08f7.webp";